
import apiService from "./apiService";


const SETTINGS_ENDPOINT = `/param-service/api/params/rules`;

export const settingsService = {
  // Fetch all settings from the API
  async getSettings() {
    try {
      const response = await apiService.get(SETTINGS_ENDPOINT);
      return response;
    } catch (error) {
      console.error("Error fetching settings:", error);
      throw error;
    }
  },

  // Update settings
  async updateSettings(settings) {
    try {
      const response = await apiService.put(SETTINGS_ENDPOINT, settings);
      return response;
    } catch (error) {
      console.error("Error updating settings:", error);
      throw error;
    }
  },
};
